import { fontWeights, fontSizes, fonts } from '@opallabs/pulsar'
import { sharedColors } from '../display/shared/colors'

const colors = {
  lightGray: '#f0f2f6',
  mediumGray: '#dfe2eb',
  lightGrayText: '#65676b',
  lightGrayBorder: '#e5e5e5',
}

const linkAssets = {
  desktopNewsFeed: {
    nonSquare: { height: '353px', width: '678px' },
    square: { height: '137px', width: '137px' },
  },
  mobileSingle: {
    nonSquare: { height: '194px', width: '373px' },
    square: { height: '194px', width: '373px' },
  },
  desktopTimeline: {
    nonSquare: { height: '259px', width: '498px' },
    square: { height: '137px', width: '137px' },
  },
}

const links = {
  desktopNewsFeed: {
    nonSquare: { width: '664px' },
    square: { width: '526px' },
  },
  mobileSingle: {
    nonSquare: { width: '359px' },
    square: { width: '359px' },
  },
  desktopTimeline: {
    nonSquare: { width: '484px' },
    square: { width: '346px' },
  },
}

const headerWrapper = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '14px 25px 0 16px',
}

const flexRow = {
  display: 'flex',
  flexDirection: 'row',
}

const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
}

const header = {
  paddingLeft: '9px',
}

const accountName = {
  fontWeight: fontWeights.bolder,
  lineHeight: '16px',
  marginTop: '4px',
}

const scheduledTimeWrapper = {
  alignItems: 'center',
  display: 'flex',
  marginTop: '2px',
}

const scheduledTime = {
  alignItems: 'center',
  color: sharedColors.lightGreyText,
  display: 'flex',
  fontFamily: fonts.sansSerif,
  fontSize: fontSizes.small,
  paddingRight: '4px',
  '.kuiper-icon-wrapper': {
    margin: '-1px 0 0 4px',
  },
}

const moreIconWrapper = {
  color: sharedColors.lightGreyText,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

const contentWrapper = {
  padding: '6px 11px',
}

const linkAssetStyle = (display, imagesLength, isFirstLinkAssetSquare) => ({
  border: `1px solid ${colors.lightGrayBorder}`,
  display: imagesLength === 0 ? 'none' : 'flex',
  height:
    imagesLength === 1 && isFirstLinkAssetSquare
      ? linkAssets[display].square.height
      : linkAssets[display].nonSquare.height,
  width:
    imagesLength === 1 && isFirstLinkAssetSquare
      ? linkAssets[display].square.width
      : linkAssets[display].nonSquare.width,
})

const linkDescriptionStyle = (display) => ({
  backgroundColor: colors.lightGray,
  border: 'none',
  color: colors.lightGrayText,
  display: display === 'mobileSingle' ? 'none' : 'inherit',
  fontSize: fonts.large,
})

const linkDomainStyle = (display, isFirstLinkAssetSquare) => ({
  backgroundColor: colors.lightGray,
  border: 'none',
  color: colors.lightGrayText,
  display: isFirstLinkAssetSquare ? 'none' : 'inherit',
  fontSize: display === 'mobileSingle' ? fonts.xsmall : fonts.small,
  textTransform: 'uppercase',
})

const linkStyle = (
  display,
  imagesLength,
  isFirstLinkAssetSquare,
  readOnly
) => ({
  backgroundColor: colors.lightGray,
  border: `1px solid ${colors.lightGrayBorder}`,
  padding: '11px 7px',
  width:
    imagesLength === 1 && isFirstLinkAssetSquare
      ? links[display].square.width
      : links[display].nonSquare.width,
  '.kuiper-input-textarea:hover': {
    '.kuiper-input-element': {
      backgroundColor: readOnly ? 'unset' : `${colors.mediumGray} !important`,
    },
  },
  '.kuiper-input-container': {
    backgroundColor: 'unset',
  },
})

const linkTitleStyle = (display) => ({
  backgroundColor: colors.lightGray,
  border: 'none',
  color: '#050505',
  fontSize: display === 'mobileSingle' ? fontSizes.medium : fontSizes.xxLarge,
  fontWeight: fontWeights.bold,
})

const previewWrapper = {
  paddingBottom: '12px',
}

const styles = {
  headerWrapper,
  flexColumn,
  flexRow,
  header,
  accountName,
  scheduledTimeWrapper,
  scheduledTime,
  moreIconWrapper,
  contentWrapper,
  linkAssetStyle,
  linkDescriptionStyle,
  linkDomainStyle,
  linkStyle,
  linkTitleStyle,
  previewWrapper,
}

export { styles }
